export const scrollToRef = (ref: React.RefObject<HTMLElement>, offset = 100) => {
  if (!ref?.current) {
    return;
  }

  let el = ref.current;
  let top = 0;
  while (el) {
    top += el.offsetTop;
    el = el.offsetParent as HTMLElement;
  }
  window.scrollTo({ top: top - offset, behavior: 'smooth' });
};
